<template>
  <span></span>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "doi",
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    buttonSettings: {
      type: Object,
      default: () => {}
    },
    imageSrc: String,
    subTitle: String,
    title: String
  },
  data: () => {
    return {
      verification_code: "",
      customerToken: "",
      sent: false
    };
  },
  computed: {
    ...mapGetters(["campaignId", "receiptToken"])
  },
  methods: {
    checkDoi () {
      return axios
        .post(this.apiUrl, {
          campaignId: this.campaignId,
          verification_code: this.verification_code,
          customerToken: this.customerToken
        })
        .then(res => res.data);
    }
  },
  mounted () {
    this.verification_code = this.$route.query.token;
    this.customerToken = this.$route.query.u;

    if (this.verification_code) {
      this.checkDoi()
    }
  }
};
</script>

<style lang="scss" scoped>
  .doi-sub-title {
    color: #252525;
  }
  .doi-title {
    text-align: center;
    color: #003478;
    font-size: 40px;
    line-height: 50px;
    font-weight: 450;
    @media (max-width: 768px) {
      font-size: 2rem;
    }
    @media (max-width: 414px) {
      font-size: 1.5rem;
    }
  }
  .doi-sub-title {
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    margin: 0 auto 0 auto;
    font-weight: 400;
    max-width: 710px;
    @media (max-width: 768px) {
      font-size: 1.125rem;
    }
  }
  .doi-image {
    width: 100%;
    max-width: 720px;
    display: block;
    margin: 0 auto 60px auto;
  }
</style>
